import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AddressService {

  constructor(private http: HttpClient) { }

  updateById(id: string, data: any) {
    return this.http.put(environment.apiUrl + `admin/addresses/${id}`, data)
      .pipe(map((result) => result));
  }
}
